enum UserType {
  Administrator = 0,
  Supervisor = 1,
  Agent = 2,
  Digitizer=3,
}

export default UserType;
